export const purchaseEn = {
  "pos.purchase.match.allocateSources": "Assign an invoice amount to each receipt",
  "pos.purchase.match.allocationHelp": "Enter explicit amounts; nothing is prorated. All selected receipt amounts must equal the selected invoice amount. Cost differences require independent review.",
  "pos.purchase.match.sourceAmount": "Invoice amount for {name} · {reference}",
  "pos.purchase.match.allocationInvalid": "Enter an amount for every selected receipt. Their sum must equal the selected invoice amount.",
  "pos.purchase.match.allocated": "Allocated {amount}",

  "pos.purchase.match.nonStockExceptionNeeded": "Independent approval must explicitly acknowledge this non-stock classification and its reason.",
  "pos.purchase.match.nonStockExceptionAck": "I reviewed the supplier evidence and accept this non-stock classification, with the reason recorded here.",

  "pos.purchase.match.reasonRequired": "Enter a reason of at least three characters.",
  "pos.purchase.ap.version": "Invoice version",
  "pos.purchase.ap.description": "Description",
  "pos.purchase.ap.distributions": "Invoice distributions",

  "pos.purchase.ap.historicalCoverage": "Native matching does not apply to historical opening documents.",
  "pos.purchase.ap.closedCoverage": "Matching history is retained for this closed document.",
  "pos.purchase.ap.title": "Supplier invoices",
  "pos.purchase.ap.help": "Review the actual invoice and its matching history. A no-PO exception classifies only documented non-stock charges; it cannot claim received or returned goods. Matching approval does not approve or post the AP invoice.",
  "pos.purchase.ap.find": "Find invoice number or description",
  "pos.purchase.ap.kind": "Document type",
  "pos.purchase.ap.empty": "No supplier invoices match these filters.",
  "pos.purchase.ap.details": "Invoice details",
  "pos.purchase.ap.date": "Invoice date",
  "pos.purchase.ap.opening": "Historical opening document: retained for reference and excluded from native matching or exceptions.",
  "pos.purchase.ap.cancelledReason": "Cancellation: {reason}",
  "pos.purchase.ap.rejectedReason": "Sent back: {reason}",
  "pos.purchase.ap.coverage": "Matching and classification",
  "pos.purchase.ap.optional": "Matching is optional unless this invoice’s policy requires it or a saved classification opts it in.",
  "pos.purchase.ap.state.draft": "Draft",
  "pos.purchase.ap.state.rejected": "Sent back",
  "pos.purchase.ap.state.pending_approval": "Awaiting AP approval",
  "pos.purchase.ap.state.approved": "Approved in AP",
  "pos.purchase.ap.state.partially_paid": "Partially paid",
  "pos.purchase.ap.state.paid": "Paid",
  "pos.purchase.ap.state.void": "Voided",
  "pos.purchase.ap.state.cancelled": "Cancelled draft",
  "pos.purchase.match.noOrderNew": "Record a no-PO exception",
  "pos.purchase.match.noOrder": "No purchase order: explicit non-stock exception. No stock quantity is matched.",
  "pos.purchase.match.noOrderHelp": "Explain why these invoice amounts are legitimate non-stock charges without a related purchase order. Reference the supplier evidence in your reason. Saving reserves these amounts and requires independent exception approval; it does not approve AP or create stock.",
  "pos.purchase.match.noOrderAck": "I reviewed the supplier evidence and this no-PO exception. Reserve the selected invoice amounts for independent review.",
  "pos.purchase.invoice.viewOrder": "View the related purchase order",

  "pos.purchase.policy.title": "Invoice matching rules",
  "pos.purchase.policy.scope": "Changes apply only to native bills and credits created after independent approval. Existing and imported invoices retain their original rules. Any required account means the whole invoice needs approved matching or non-stock classification before submission.",
  "pos.purchase.policy.open": "View invoice matching rules",
  "pos.purchase.policy.enabled": "Mandatory matching is enabled for these accounts.",
  "pos.purchase.policy.off": "No mandatory accounts for future invoices",
  "pos.purchase.policy.propose": "Propose invoice matching rules",
  "pos.purchase.policy.history": "Policy proposals and decisions",
  "pos.purchase.policy.approvedBy": "Approved by {name} · {when}",
  "pos.purchase.policy.empty": "No policy proposals. Matching is optional until a policy is independently approved.",
  "pos.purchase.policy.current": "Current policy",
  "pos.purchase.policy.stale": "A newer policy has been approved. Reject this proposal and review a replacement against the current policy.",
  "pos.purchase.policy.approve": "Approve for future invoices",
  "pos.purchase.policy.reject": "Reject policy proposal",
  "pos.purchase.policy.mode": "Future invoice rules",
  "pos.purchase.policy.require": "Require matching for selected accounts",
  "pos.purchase.policy.ack": "I reviewed the accounts and future-invoice scope. Record this policy request and retain its evidence.",
  "pos.purchase.policy.state.pending": "Awaiting independent review",
  "pos.purchase.policy.state.approve": "Approved policy",
  "pos.purchase.policy.state.reject": "Rejected proposal",
  "pos.purchase.policy.action.approve": "Approve for future invoices",
  "pos.purchase.policy.action.reject": "Reject proposal",
  "pos.purchase.policy.requiredBecause": "This invoice’s original policy requires full matching because it includes: {accounts}.",

  "pos.purchase.match.uncertain": "The result is unconfirmed. Keep this request unchanged and retry to recover its result. Do not create a new matching request.",
  "pos.purchase.invoice.cancel.title": "Cancel draft invoice",
  "pos.purchase.invoice.cancel.help": "Retain this invoice and its matching history as cancelled. Release all active matches first. No accounting journal or stock movement is created.",
  "pos.purchase.invoice.cancel.reason": "Cancellation reason",
  "pos.purchase.invoice.cancel.confirm": "Confirm cancellation",
  "pos.purchase.invoice.cancel.uncertain": "The response was lost. Retry this same cancellation to check its outcome.",

  "pos.purchase.match.nonStockBasis": "Stock cost comparisons do not apply to a non-stock charge.",
  "pos.purchase.match.history": "Saved invoice matches",
  "pos.purchase.match.help": "Saved matches hold receipt/return quantities and invoice amounts until independent review or explicit release. AP approval is separate.",
  "pos.purchase.match.showHistory": "Show saved matches",
  "pos.purchase.match.new": "Create saved invoice match",
  "pos.purchase.match.empty": "No saved matches for this purchase order.",
  "pos.purchase.match.saveHelp": "Choose goods quantities or a non-stock classification and explicit invoice amounts. The first saved match requires full reviewed classification of this invoice before AP submission. Saving does not approve or post it.",
  "pos.purchase.match.version": "Invoice version {version}",
  "pos.purchase.match.line": "Invoice line {number}",
  "pos.purchase.match.category": "Match classification",
  "pos.purchase.match.category.goods": "Goods received / returned",
  "pos.purchase.match.category.freight": "Freight",
  "pos.purchase.match.category.tax": "Tax",
  "pos.purchase.match.category.service": "Service",
  "pos.purchase.match.category.restocking": "Restocking fee",
  "pos.purchase.match.category.other": "Other non-stock charge",
  "pos.purchase.match.exceptionNeeded": "Independent approval must explicitly acknowledge the cost difference, missing supplier basis or non-stock classification.",
  "pos.purchase.match.approve": "Review and approve match",
  "pos.purchase.match.reject": "Reject match",
  "pos.purchase.match.release": "Release reservations",
  "pos.purchase.match.action.approve": "Approved",
  "pos.purchase.match.action.reject": "Rejected",
  "pos.purchase.match.action.release": "Released",
  "pos.purchase.match.state.pending": "Awaiting independent review",
  "pos.purchase.match.state.approved": "Approved matching",
  "pos.purchase.match.state.rejected": "Rejected",
  "pos.purchase.match.state.released": "Released",
  "pos.purchase.match.availableAmount": "{amount} available",
  "pos.purchase.match.availableQuantity": "{quantity} stock units available",
  "pos.purchase.match.amount": "Match amount · invoice line {number}",
  "pos.purchase.match.invalidAmount": "Select invoice lines and enter positive amounts.",
  "pos.purchase.match.coverageDone": "All invoice lines have approved matching coverage.",
  "pos.purchase.match.coverageOpen": "Invoice classification still needs independent approval.",
  "pos.purchase.match.billState": "Create matches on a draft or rejected invoice. Existing AP approval and void controls remain separate.",
  "pos.purchase.match.save": "Save and reserve for review",
  "pos.purchase.match.saveAck": "I reviewed these quantities and amounts and want to reserve them for independent review.",
  "pos.purchase.match.exceptionAck": "I reviewed and accept the cost difference, missing supplier evidence or non-stock classification, with the reason recorded here.",
  "pos.purchase.match.decisionAck": "Record this matching decision and retain its review evidence.",
  "pos.purchase.match.releaseHelp": "Release removes the quantity and amount reservations; it does not undo stock or financial postings. Reject or void an invoice in AP before releasing approved matching from a submitted or posted invoice.",
  "pos.purchase.invoice.currencyMismatch": "This order uses a different currency from accounts payable. Review currency conversion separately.",
  "pos.purchase.invoice.reload": "Reload invoice and source evidence",
  "pos.purchase.invoice.title": "Supplier invoice comparison",
  "pos.purchase.invoice.help": "Compare AP invoice distributions with this order’s receipts or physical supplier returns. Select quantities explicitly; totals alone do not identify a match.",
  "pos.purchase.invoice.open": "Compare an invoice or credit",
  "pos.purchase.invoice.choose": "Supplier invoice or credit",
  "pos.purchase.invoice.kind.bill": "Bill",
  "pos.purchase.invoice.kind.credit": "Vendor credit",
  "pos.purchase.invoice.opening": "Historical opening — not eligible",
  "pos.purchase.invoice.empty": "No AP bills or credits exist for this supplier.",
  "pos.purchase.invoice.distributions": "1. Invoice lines",
  "pos.purchase.invoice.linesHelp": "Choose the goods distributions you want to compare. Leave freight, tax and other charges separate when applicable.",
  "pos.purchase.invoice.total": "Full invoice total",
  "pos.purchase.invoice.sources.bill": "2. Receipt quantities",
  "pos.purchase.invoice.sources.credit": "2. Supplier return quantities",
  "pos.purchase.invoice.noSources": "No source quantities exist for this order and document type.",
  "pos.purchase.invoice.sourceQuantity": "Original source quantity",
  "pos.purchase.invoice.stock": "Stock valuation",
  "pos.purchase.invoice.supplier": "Supplier cost basis",
  "pos.purchase.invoice.unknown": "Needs supplier evidence",
  "pos.purchase.invoice.reversed": "Reversed — select another source",
  "pos.purchase.invoice.quantity": "Compare stock quantity · {name}",
  "pos.purchase.invoice.compare": "Review comparison",
  "pos.purchase.invoice.result": "3. Cost comparison",
  "pos.purchase.invoice.selected": "Selected invoice amount",
  "pos.purchase.invoice.invoiceDifference": "Invoice minus supplier cost",
  "pos.purchase.invoice.roundingDifference": "Supplier cost minus stock valuation",
  "pos.purchase.invoice.stockDifference": "Invoice minus stock valuation",
  "pos.purchase.invoice.issue.partial_invoice": "Only selected invoice lines are included; other charges remain outside this comparison.",
  "pos.purchase.invoice.issue.posted_invoice": "This invoice is already posted. This review does not change or post it again.",
  "pos.purchase.invoice.issue.returned_goods": "Some goods were returned. The original receipt remains the bill basis; review the supplier credit separately.",
  "pos.purchase.invoice.issue.unknown_supplier_basis": "A supplier amount is missing for selected loose/partial pack quantities or returns. Stock cost is shown separately.",
  "pos.purchase.invoice.issue.amount_difference": "Selected invoice and supplier costs differ. Investigate price, quantity, rounding and other charges before recording a match.",
  "pos.purchase.invoice.equal": "The selected amounts agree. This does not prove item-level invoice quantities or an approved match.",
  "pos.purchase.invoice.notMatched": "Comparison only. No match is saved, no quantity is reserved, and no stock, payable or journal is changed. Use saved invoice matches for reservations and independent review.",
  "pos.purchase.unit.use": "Order in packs · {name}",
  "pos.purchase.unit.label": "Purchase-unit label · {name}",
  "pos.purchase.unit.factor": "Stock units per purchase unit · {name}",
  "pos.purchase.unit.quantity": "Purchase quantity · {name}",
  "pos.purchase.unit.cost": "Cost per purchase unit · {name}",
  "pos.purchase.unit.calculate": "Calculate stock conversion",
  "pos.purchase.unit.help": "Enter the supplier pack definition explicitly. Recalculate after any change. Stock quantities must convert exactly; stock-unit costs round half up to four decimals.",
  "pos.purchase.unit.conversion": "{quantity} {label} × {factor} stock units = {stock} stock units",
  "pos.purchase.unit.supplier": "Supplier purchase cost",
  "pos.purchase.unit.stock": "Stock valuation",
  "pos.purchase.unit.difference": "Supplier cost minus stock valuation",
  "pos.purchase.unit.ack": "I reviewed this cost difference and will reconcile it with the supplier invoice.",
  "pos.purchase.unit.notPosted": "This difference is retained for invoice reconciliation; no payable or GL adjustment is posted.",
  "pos.purchase.unit.receiveIn": "Receive in purchase units · {name}",
  "pos.purchase.unit.receiveQuantity": "Receive purchase quantity · {name}",
  "pos.purchase.unit.received": "Received purchase units",
  "pos.purchase.unit.recalculate": "Recalculate the remaining purchase quantity before reviewing this replacement.",
  "pos.purchase.supplierReturned": "Supplier returned",
  "pos.purchase.supplierReturnedCost": "Supplier-return stock cost",
  "pos.purchase.supplierReturnHelp": "Supplier returns reduce current stock. Original fulfillment and receiving costs remain historical; replacements require a separate commitment.",
  "pos.purchase.revision.title": "Revise outstanding order",
  "pos.purchase.revision.help": "Review a linked replacement for the remaining commitment. The original order will close; received goods and their original stock costs stay on it. Nothing is sent to the supplier or posted to stock, payables or GL.",
  "pos.purchase.revision.formHelp": "Enter quantities still to order, excluding goods already received. Review supplier, location, dates and future delivery costs before approving the replacement.",
  "pos.purchase.revision.quantity": "Quantity still to order",
  "pos.purchase.revision.preview": "Review replacement",
  "pos.purchase.revision.before": "Original received and remaining quantities",
  "pos.purchase.revision.after": "Proposed remaining commitment",
  "pos.purchase.revision.remainingCost": "New remaining commitment cost",
  "pos.purchase.revision.ack": "I checked the received goods, replacement quantities and costs, and approve closing the original remaining commitment",
  "pos.purchase.revision.confirm": "Approve linked replacement",
  "pos.purchase.revision.receipt": "View revision review",
  "pos.purchase.revision.lineage": "Purchase revision history",
  "pos.purchase.revision.superseded": "This remaining commitment moved to the linked replacement. Continue receiving and revising there; original receipts remain here.",
  "pos.purchase.revision.original": "Open original order",
  "pos.purchase.revision.replacement": "Open replacement order",

  "pos.purchase.title": "Purchase orders",
  "pos.purchase.subtitle": "Review supplier commitments and receive approved stock quantities.",
  "pos.purchase.new": "New purchase order",
  "pos.purchase.number": "Purchase order {number}",
  "pos.purchase.supplier": "Supplier",
  "pos.purchase.searchSupplier": "Find a supplier",
  "pos.purchase.searchItems": "Find stock by name or SKU",
  "pos.purchase.location": "Receive into",
  "pos.purchase.orderedOn": "Order date",
  "pos.purchase.expectedOn": "Expected delivery",
  "pos.purchase.reference": "Supplier reference",
  "pos.purchase.notes": "Notes",
  "pos.purchase.item": "Stock item",
  "pos.purchase.quantity": "Ordered quantity",
  "pos.purchase.unitCost": "Cost per stock unit",
  "pos.purchase.add": "Add item",
  "pos.purchase.remove": "Remove",
  "pos.purchase.save": "Save draft",
  "pos.purchase.edit": "Edit draft",
  "pos.purchase.back": "All purchase orders",
  "pos.purchase.status": "Status",
  "pos.purchase.status.draft": "Draft",
  "pos.purchase.status.approved": "Approved",
  "pos.purchase.status.closed": "Closed",
  "pos.purchase.status.cancelled": "Cancelled",
  "pos.purchase.filter": "Find supplier or reference",
  "pos.purchase.all": "All statuses",
  "pos.purchase.empty": "No purchase orders yet.",
  "pos.purchase.orderedCost": "Ordered stock cost",
  "pos.purchase.receivedCost": "Net received stock cost",
  "pos.purchase.costBasis": "Costs are in stock units and exclude tax, freight and supplier invoice charges. Approval does not send an order to the supplier.",
  "pos.purchase.approve": "Approve order",
  "pos.purchase.close": "Close remaining commitment",
  "pos.purchase.reopen": "Reopen for receiving",
  "pos.purchase.cancel": "Cancel draft",
  "pos.purchase.reason": "Reason",
  "pos.purchase.review": "Review action",
  "pos.purchase.confirm": "Confirm reviewed action",
  "pos.purchase.ack": "I reviewed the supplier, location, quantities and stock-unit costs.",
  "pos.purchase.receive": "Receive stock",
  "pos.purchase.receivingDate": "Received date",
  "pos.purchase.deliveryRef": "Delivery reference",
  "pos.purchase.receiveQuantity": "Receive quantity · {name}",
  "pos.purchase.reviewReceive": "Review receipt",
  "pos.purchase.postReceive": "Confirm goods received",
  "pos.purchase.receiveAck": "I counted these goods and reviewed their approved stock-unit costs.",
  "pos.purchase.received": "Received",
  "pos.purchase.reversed": "Reversed",
  "pos.purchase.netReceived": "Net received",
  "pos.purchase.remaining": "Outstanding",
  "pos.purchase.receiptCost": "This receipt’s stock cost",
  "pos.purchase.receipts": "Receipt history",
  "pos.purchase.events": "Approval and closure history",
  "pos.purchase.noReceipts": "No receipts against this order.",
  "pos.purchase.noEvents": "No approval or closure actions yet.",
  "pos.purchase.exact": "Use decimal points and up to four decimal places. Blank receipt quantities are not received.",
  "pos.purchase.invalid": "Choose a supplier and location, add stock lines and enter exact positive quantities and nonnegative costs.",
  "pos.purchase.uncertain": "The result is unconfirmed. Keep this request unchanged and retry to recover its result. Do not record this delivery again.",
  "pos.purchase.retry": "Retry the same request",
  "pos.purchase.reload": "Reload and review again",
  "pos.purchase.saved": "Purchase order saved.",
  "pos.purchase.draftOnly": "Save changes before requesting approval. Approved order lines are retained unchanged.",
  "pos.purchase.closedHelp": "Receiving is closed. Outstanding quantities remain visible; a manager must review reopening before another delivery.",
  "pos.purchase.archived": "Archived sale item",
  "pos.purchase.noMatches": "No matching choices. Refine the search.",
  "pos.purchase.choose": "Choose…",
  "pos.purchase.changed": "The order changed. Reload before making another review."
};

export type PurchaseMessages = typeof purchaseEn;
